import { usePermissionsStore } from "../../permissions/permissions_store";
import classnames from "classnames";
import moment from "moment";
import { Image } from "uikit-react";

import FeatherIcon from "../../common/FeatherIcon";

export const AirbnbThreadCard = ({
  thread,
  selected,
  handleSelect,
  togglePersonalMeta,
  setPersonalMeta,
  isMetaPending,
}) => {
  const { canEdit } = usePermissionsStore();
  const canManage = canEdit("messaging.messages");
  // TODO if we ever have multiple sources for the threads this
  // will have to be smarter
  let source = (thread.sources || []).find(
    (item) => String(item?.ota || "").trim().toLowerCase() === "airbnb",
  );
  let otaThread = source?.thread;
  let otaReservation = (otaThread?.reservation || [])[0];
  let otaGuest = otaReservation?.guest;
  let otaRental = otaReservation?.listing;

  console.log("OTA GUESt", otaRental);

  // if (!otaReservation) {
  //   // Just for testing locally. Remove
  //   otaReservation = [
  //     {
  //       id: 41,
  //       thread_id: "2448711886",
  //       reservation: [
  //         {
  //           id: 14,
  //           guest: {
  //             id: 1,
  //             user_id: "740027153",
  //             first_name: "Host",
  //           },
  //           listing: {
  //             id: 1,
  //             lat: 42.4046569,
  //             lng: -71.1328524,
  //             city: "Somerville",
  //             name: "Test House",
  //             state: "MA",
  //             street: "42 Waterhouse Street",
  //             user_id: 1,
  //             zipcode: "02144",
  //             nickname: "",
  //             listing_id: "1598052350663155758",
  //             country_code: "US",
  //           },
  //           user_id: 5,
  //           category: null,
  //           end_date: "2026-03-02",
  //           guest_id: 1,
  //           timezone: null,
  //           booked_at: null,
  //           thread_id: 41,
  //           created_at: "2026-03-10T21:45:54.837397",
  //           listing_id: 1,
  //           start_date: "2026-03-01",
  //           updated_at: "2026-03-12T19:31:09.000968",
  //           status_type: "accepted",
  //           guest_id_str: "740027153",
  //           thread_id_str: "2448711886",
  //           listing_id_str: "1598052350663155758",
  //           check_in_datetime: null,
  //           confirmation_code: "HMW85Q5HJC",
  //           check_out_datetime: null,
  //         },
  //       ],
  //     },
  //     {
  //       id: 75,
  //       thread_id: "2469349001",
  //       reservation: [
  //         {
  //           id: 48,
  //           guest: {
  //             id: 1,
  //             user_id: "740027320",
  //             first_name: "Temporary",
  //           },
  //           listing: {
  //             id: 1,
  //             lat: 42.4046569,
  //             lng: -71.1328524,
  //             city: "Somerville",
  //             name: "Test House",
  //             state: "MA",
  //             street: "42 Waterhouse Street",
  //             user_id: 1,
  //             zipcode: "02144",
  //             nickname: "",
  //             listing_id: "1598052350663155758",
  //             country_code: "US",
  //           },
  //           user_id: 5,
  //           category: null,
  //           end_date: "2026-04-08",
  //           guest_id: 1,
  //           timezone: null,
  //           booked_at: null,
  //           thread_id: 75,
  //           created_at: "2026-03-12T19:41:34.957492",
  //           listing_id: 1,
  //           start_date: "2026-04-01",
  //           updated_at: "2026-03-12T19:44:19.777258",
  //           status_type: "pending",
  //           guest_id_str: "740027153",
  //           thread_id_str: "2469349001",
  //           listing_id_str: "1598052350663155758",
  //           check_in_datetime: null,
  //           confirmation_code: "HMXMPRTCZ2",
  //           check_out_datetime: null,
  //         },
  //       ],
  //     },
  //   ];
  // }

  // if (!otaGuest) {
  //   otaGuest = {
  //     id: 1,
  //     user_id: "740027320",
  //     first_name: "Temporary",
  //   };
  // }

  // if (!otaRental) {
  //   otaRental = {
  //     id: 1,
  //     lat: 42.4046569,
  //     lng: -71.1328524,
  //     city: "Somerville",
  //     name: "Test House",
  //     state: "MA",
  //     street: "42 Waterhouse Street",
  //     user_id: 1,
  //     zipcode: "02144",
  //     nickname: "",
  //     listing_id: "1598052350663155758",
  //     country_code: "US",
  //   };
  // }

  let { last_msg } = thread;
  const guestName = [otaGuest?.first_name, otaGuest?.last_name]
    .filter(Boolean)
    .join(" ") ||
    [thread.guest_first_name, thread.guest_last_name]
      .filter(Boolean)
      .join(" ") ||
    [thread.contact_first_name, thread.contact_last_name]
      .filter(Boolean)
      .join(" ") ||
    "[Unknown]";
  const listingName = otaRental?.name || thread.unit_code || "[Unknown]";
  const metaValues = thread.meta_values || [];
  const isUnread = metaValues.indexOf("unread") >= 0;
  const readPending = isMetaPending(thread.id, "unread");
  const priorityPending = isMetaPending(thread.id, "priority");
  const archivePending = isMetaPending(thread.id, "archived");

  return (
    <div
      data-thread-id={thread.id}
      data-preview-message-id={thread.last_message_id}
      className={classnames("chat-guest-contact-wrapper", {
        "active-chat-guest-contact": selected,
        "thread-unread": isUnread,
      })}
      key={thread.id}
    >
      <div
        className="message-text-group"
        onClick={() => {
          handleSelect(thread.id);
        }}
      >
        <span
          className="message-text-group-icon"
          uk-tooltip={`title: ${
            thread.contact_category
              ?.toLowerCase()
              .replace(/\b\w/g, (s) => s.toUpperCase()) || "Guest"
          }; pos: bottom-left; cls: uk-active contact-tooltip`}
        >
          <Image src="/images/guest-active.svg" />
          <Image className="airbnb-icon" src="/images/airbnb.svg" />
        </span>

        <div>
          <div className="semi-bold-font">{guestName}</div>
          <div
            className="chat-guest-contact-address uk-margin-tiny-top uk-margin-tiny-bottom"
            uk-tooltip={listingName}
          >
            {listingName.length > 30
              ? listingName.slice(0, 30)
              : listingName}
          </div>

          <div
            className={
              isUnread
                ? "chat-guest-unread-message"
                : "chat-guest-message"
            }
          >
            {last_msg?.length > 60 ? `${last_msg.slice(0, 60)}...` : last_msg}
          </div>
          <div>
            {metaValues.indexOf("unhandled") === -1 && (
              <span
                className="chat-guest-handled"
                aria-label="Handled"
                uk-tooltip="Handled"
              >
                <FeatherIcon
                  name="check"
                  className="handled-icon"
                  color="#28a745"
                />
              </span>
            )}
          </div>
          <div className="chat-guest-contact-date">
            {moment
              .utc(thread.last_message_on)
              .local()
              .format("MMM DD, YYYY hh:mm a")}
          </div>
        </div>
      </div>
      <div className="messages-btn-group">
        <button
          type="button"
          className="uk-button hms-simple-icon-btn inbox-read-state-indicator"
          onClick={() => setPersonalMeta(thread.id, "unread", !isUnread)}
          disabled={!canManage || readPending}
          aria-busy={readPending}
          uk-tooltip={isUnread ? "Mark as Read" : "Mark as Unread"}
        >
          {readPending ? (
            <span uk-spinner="ratio: 0.6" aria-label="Updating read status" />
          ) : isUnread ? (
            <FeatherIcon
              name="eye-off"
              className="inbox-action-icon inbox-read-state-icon"
              color="inherit"
            />
          ) : (
            <FeatherIcon
              name="eye"
              className="inbox-action-icon inbox-read-state-icon"
              color="inherit"
            />
          )}
        </button>
        <button
          className={classnames("uk-button hms-simple-icon-btn", {
            "icon-active icon-priority":
              thread.meta_values.indexOf("priority") >= 0,
          })}
          onClick={() => togglePersonalMeta(thread.id, "priority", true)}
          disabled={!canManage || priorityPending}
          aria-busy={priorityPending}
          uk-tooltip={
            thread.meta_values.indexOf("priority") >= 0
              ? "Unprioritize"
              : "Prioritize"
          }
        >
          {priorityPending ? (
            <span uk-spinner="ratio: 0.6" aria-label="Updating priority" />
          ) : (
            <FeatherIcon
              name="flag"
              className="inbox-action-icon"
              color="inherit"
            />
          )}
        </button>
        <button
          className={classnames("uk-button hms-simple-icon-btn", {
            "icon-active icon-archived":
              thread.meta_values.indexOf("archived") >= 0,
          })}
          onClick={() => togglePersonalMeta(thread.id, "archived")}
          disabled={!canManage || archivePending}
          aria-busy={archivePending}
          uk-tooltip={
            thread.meta_values.indexOf("archived") >= 0
              ? "Unarchive"
              : "Archive"
          }
        >
          {archivePending ? (
            <span uk-spinner="ratio: 0.6" aria-label="Updating archive status" />
          ) : (
            <FeatherIcon
              name="archive"
              className="inbox-action-icon"
              color="inherit"
            />
          )}
        </button>
      </div>
    </div>
  );
};
